import React, { useState } from 'react';
import '../styles/VerifiedCredentialsBlock.css';

const VerifiedCredentialsBlock = () => {
  const [activeTab, setActiveTab] = useState('main');
  console.log('VerifiedCredentialsBlock renderizado');

  const ChartMain = () => {
    const data = [
      { month: 'May 2025', value: 50.85, color: '#B19CD9' },
      { month: 'Jun 2025', value: 6.03, color: '#FF9999' },
      { month: 'Jul 2025', value: 17.69, color: '#5BA4A4' },
      { month: 'Aug 2025', value: 8.98, color: '#FFB366' },
      { month: 'Sep 2025', value: 17.50, color: '#B3E66B' },
      { month: 'Oct 2025', value: 10.41, color: '#FFEB99' },
      { month: 'Nov 2025', value: 1.83, color: '#B3D9FF' },
      { month: 'Dec 2025', value: 5.30, color: '#B3D966' },
    ];
    const maxValue = 50.85;
    return (
      <div className="chart-container">
        <div className="chart-header">
          <h3>Monthly Gain(Change)</h3>
          <p className="chart-subtitle">2025 Monthly Returns</p>
        </div>
        <div className="chart-main">
          {data.map((item, i) => (
            <div key={i} className="bar-item">
              <div className="bar-wrapper">
                <div className="bar" style={{ height: `${(item.value / maxValue) * 300}px`, background: item.color }} />
              </div>
              <div className="bar-label">
                <span className="month">{item.month}</span>
                <span className="value" style={{ color: '#000000' }}>{item.value}%</span>
              </div>
            </div>
          ))}
        </div>
        <div className="chart-footer">
          <p>📊 Monthly Performance Data</p>
        </div>
      </div>
    );
  };

  const Chart1 = () => {
    const data = [
      { month: 'Jan 2025', value: 4.72, color: '#B19CD9' },
      { month: 'Feb 2025', value: 1.22, color: '#FF9999' },
      { month: 'Mar 2025', value: -0.71, color: '#5BA4A4' },
      { month: 'Apr 2025', value: 4.07, color: '#FFB366' },
      { month: 'May 2025', value: 5.93, color: '#B3E66B' },
      { month: 'Jun 2025', value: 8.21, color: '#FFEB99' },
      { month: 'Jul 2025', value: 3.06, color: '#B3D9FF' },
      { month: 'Aug 2025', value: 2.09, color: '#B3D966' },
      { month: 'Sep 2025', value: 3.71, color: '#B19CD9' },
      { month: 'Oct 2025', value: 2.86, color: '#B3E66B' },
      { month: 'Nov 2025', value: 4.49, color: '#FF9999' },
      { month: 'Dec 2025', value: 0.36, color: '#B3D9FF' },
    ];

    const maxValue = 8.21;

    return (
      <div className="chart-container">
        <div className="chart-header">
          <h3>Monthly Gain(Change)</h3>
          <p className="chart-subtitle">2025 Full Year Performance</p>
        </div>
        <div className="chart-bars-4">
          {data.map((item, i) => (
            <div key={i} className="risk-bar-item">
              <span className="bar-value-top" style={{ color: item.value >= 0 ? '#000000' : '#FF6B6B' }}>
                {item.value > 0 ? '' : ''}{item.value}%
              </span>
              <div className="risk-bar-wrapper">
                <div className="risk-bar" style={{ height: `${(Math.abs(item.value) / maxValue) * 250}px`, background: item.color }} />
              </div>
              <div className="risk-label">
                <span className="risk-month">{item.month.split(' ')[0]}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="chart-footer">
          <p>Monthly returns with positive and negative values</p>
        </div>
      </div>
    );
  };

  const Chart2 = () => {
    const months = ['Jan 2025', 'Feb 2025', 'Mar 2025', 'Apr 2025', 'May 2025', 'Jun 2025', 'Jul 2025', 'Aug 2025', 'Sep 2025', 'Oct 2025', 'Nov 2025', 'Dec 2025'];
    const values = [7.40, 10.67, 33.12, 9.12, 8.53, 12.74, 12.10, 5.62, 14.00, 9.97, 9.11, 2.54];
    const colors = ['#B19CD9', '#FF9999', '#5BA4A4', '#FFB366', '#B3E66B', '#FFEB99', '#B3D9FF', '#B3D966', '#B19CD9', '#B3E66B', '#FF9999', '#B3D9FF'];
    const maxValue = 33.12;

    return (
      <div className="chart-container">
        <div className="chart-header">
          <h3>Monthly Gain(Change)</h3>
          <p className="chart-subtitle">2025 Full Year Performance</p>
        </div>
        <div className="chart-bars-2">
          {months.map((m, i) => (
            <div key={i} className="month-bar-item">
              <div className="month-bar-wrapper">
                <div className="month-bar" style={{ height: `${(values[i] / maxValue) * 250}px`, background: colors[i] }} />
              </div>
              <div className="month-label">
                <span>{m.split(' ')[0]}</span>
                <span className="return-value" style={{ color: '#000000' }}>{values[i]}%</span>
              </div>
            </div>
          ))}
        </div>
        <div className="chart-footer">
          <p>Full year 2025 monthly returns with multiple color bands</p>
        </div>
      </div>
    );
  };

  const Chart3 = () => (
    <div className="chart-container">
      <div className="chart-header">
        <h3>Growth & Drawdown Analysis</h3>
        <p className="chart-subtitle">Equity vs Growth with Deposits/Withdrawals</p>
      </div>
      <svg viewBox="0 0 1000 500" className="chart-svg" style={{ width: '100%', height: 'auto' }}>
        <defs>
          <linearGradient id="grad-green" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#B3E66B', stopOpacity: 0.3 }} />
            <stop offset="100%" style={{ stopColor: '#B3E66B', stopOpacity: 0 }} />
          </linearGradient>
        </defs>
        
        {/* Grid */}
        <line x1="100" y1="50" x2="100" y2="400" stroke="#ddd" strokeWidth="1" />
        <line x1="100" y1="400" x2="950" y2="400" stroke="#ddd" strokeWidth="1" />
        
        {/* Small candles (equity fluctuation) */}
        {[150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850].map((x, i) => (
          <line key={i} x1={x} y1={Math.random() * 100 + 250} x2={x} y2={Math.random() * 100 + 320} stroke="#B3E66B" strokeWidth="2" opacity="0.6" />
        ))}
        
        {/* Main growth line (RED) */}
        <polyline points="150,350 200,330 250,300 300,250 350,200 400,160 450,120 500,80 550,60 600,50 650,80 700,130 750,200 800,300 850,380" 
                  fill="none" stroke="#FF6B6B" strokeWidth="4" />
        
        {/* Equity line (YELLOW) */}
        <polyline points="150,365 200,350 250,330 300,290 350,250 400,220 450,190 500,160 550,140 600,130 650,160 700,210 750,280 800,350 850,390" 
                  fill="url(#grad-green)" stroke="#FFD700" strokeWidth="3" />
        
        {/* Deposit markers (GREEN dots) */}
        <circle cx="150" cy="365" r="6" fill="#4CAF50" stroke="white" strokeWidth="2" />
        <circle cx="400" cy="220" r="6" fill="#4CAF50" stroke="white" strokeWidth="2" />
        <circle cx="750" cy="280" r="6" fill="#4CAF50" stroke="white" strokeWidth="2" />
        
        {/* Withdrawal markers (RED dots) */}
        <circle cx="300" cy="250" r="6" fill="#FF6B6B" stroke="white" strokeWidth="2" />
        <circle cx="550" cy="140" r="6" fill="#FF6B6B" stroke="white" strokeWidth="2" />
        <circle cx="700" cy="210" r="6" fill="#FF6B6B" stroke="white" strokeWidth="2" />
        
        {/* Legend */}
        <text x="150" y="450" fontSize="13" fontWeight="bold" fill="#FFD700">— Equity Growth</text>
        <text x="350" y="450" fontSize="13" fontWeight="bold" fill="#FF6B6B">— Growth</text>
        <text x="550" y="450" fontSize="12" fill="#4CAF50">● Deposit</text>
        <text x="700" y="450" fontSize="12" fill="#FF6B6B">● Withdrawal</text>
      </svg>
      <div className="chart-footer">
        <p>Growth and equity comparison with deposit/withdrawal tracking</p>
      </div>
    </div>
  );

  const Chart4 = () => {
    const data = [
      { month: 'Jan 2025', value: 4.72, color: '#B19CD9' },
      { month: 'Feb 2025', value: 1.22, color: '#FF9999' },
      { month: 'Mar 2025', value: -0.71, color: '#5BA4A4' },
      { month: 'Apr 2025', value: 4.07, color: '#FFB366' },
      { month: 'May 2025', value: 5.93, color: '#B3E66B' },
      { month: 'Jun 2025', value: 8.21, color: '#FFEB99' },
      { month: 'Jul 2025', value: 3.06, color: '#B3D9FF' },
      { month: 'Aug 2025', value: 2.09, color: '#B3D966' },
      { month: 'Sep 2025', value: 3.71, color: '#B19CD9' },
      { month: 'Oct 2025', value: 2.86, color: '#B3E66B' },
      { month: 'Nov 2025', value: 4.49, color: '#FF9999' },
      { month: 'Dec 2025', value: 0.36, color: '#B3D9FF' },
    ];

    const maxValue = 8.21;

    return (
      <div className="chart-container">
        <div className="chart-header">
          <h3>Monthly Gain(Change)</h3>
          <p className="chart-subtitle">Conservative Account - Lower Volatility</p>
        </div>
        <div className="chart-bars-4">
          {data.map((item, i) => (
            <div key={i} className="risk-bar-item">
              <div className="risk-bar-wrapper">
                <div className="risk-bar" style={{ height: `${(Math.abs(item.value) / maxValue) * 250}px`, background: item.color }} />
              </div>
              <div className="risk-label">
                <span className="risk-month">{item.month.split(' ')[0]}</span>
                <span className="risk-value" style={{ color: item.value >= 0 ? '#333' : '#FF6B6B' }}>{item.value > 0 ? '+' : ''}{item.value}%</span>
              </div>
            </div>
          ))}
        </div>
        <div className="chart-footer">
          <p>Conservative strategy with controlled risk and lower monthly volatility</p>
        </div>
      </div>
    );
  };

  return (
    <div className="verified-credentials-block" style={{ display: 'block', width: '100%', minHeight: '500px', background: 'white', padding: '80px 20px' }}>
      <div className="credentials-hero" style={{ display: 'block', textAlign: 'center', marginBottom: '80px' }}>
        <div className="hero-badge">
          <span className="badge-icon">🥇</span>
          <span>RESULTADOS AUDITADOS</span>
        </div>
        <h2 className="hero-title" style={{ fontSize: '48px', fontWeight: '900', color: '#0a0a0a', marginBottom: '20px' }}>¿Por qué me diferencio del 99% de los traders?</h2>
        <p className="hero-subtitle" style={{ fontSize: '20px', color: '#666', maxWidth: '600px', margin: '0 auto' }}>Porque soy de los pocos que tiene resultados auditados y verificables.</p>
      </div>

      <div className="credentials-content">
        {/* <div className="text-section">
          <h3>✅ Transparencia Total</h3>
          <p>Todos mis resultados están públicamente auditados y verificables. No hay secretos, no hay promesas vacías. Puedes ver exactamente cómo opero y qué resultados obtengo.</p>
        </div> */}

        <div className="verification-badge">
          <div className="badge-circle">
            <span className="badge-check">✓</span>
          </div>
          <h3>Cuentas Verificadas</h3>
          <p>1 cuenta pública + 4 cuentas privadas auditadas</p>
        </div>

        <div className="text-section">
          <h3>📊 Estrategia Comprobada</h3>
          <p>Mi metodología ha sido testeada en múltiples condiciones de mercado. Los resultados hablan por sí solos: consistencia, control de riesgo y crecimiento sostenible.</p>
        </div>

        <div className="text-section">
          <h3>🎯 Resultados Consistentes</h3>
          <p>Más del 90% de meses positivos. Max drawdown controlado. Recuperación rápida de pérdidas. Esto no es suerte, es disciplina y experiencia.</p>
        </div>
      </div>

      <div className="charts-section">
        <h2 className="charts-title">Mis Cuentas Auditadas</h2>

        <div className="tabs-navigation">
          <button className={`tab-button ${activeTab === 'main' ? 'active' : ''}`} onClick={() => setActiveTab('main')}>📈 Cuenta Pública</button>
          <button className={`tab-button ${activeTab === 'chart1' ? 'active' : ''}`} onClick={() => setActiveTab('chart1')}>💰 Privada #1</button>
          <button className={`tab-button ${activeTab === 'chart2' ? 'active' : ''}`} onClick={() => setActiveTab('chart2')}>📊 Privada #2</button>
        </div>

        <div className="chart-content">
          {activeTab === 'main' && <ChartMain />}
          {activeTab === 'chart1' && <Chart1 />}
          {activeTab === 'chart2' && <Chart2 />}
        </div>

        <div className="audit-section">
          <a href="https://www.myfxbook.com/members/alfomarin2/fondo-de-inversi%C3%B3n-3/11735781" target="_blank" rel="noopener noreferrer" className="audit-button">🔗 Ver Auditoría Completa en MyFxBook</a>
        </div>
      </div>

      <div className="private-notice">
        <div className="notice-content">
          <span className="notice-icon">🔒</span>
          <p>Las cuentas privadas están bajo protección. Solo les muestro detalles completos a mis estudiantes en el entrenamiento intensivo.</p>
        </div>
      </div>

      <div className="credentials-cta">
        <h3>¿Listo para aprender mi estrategia?</h3>
        <p>¿Listo para ver cómo ejecuta un profesional en tiempo real? Este sprint es para tomar una decisión consciente.</p>
        <button className="cta-button-credentials" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          Asegura mi cupo por 99 USD
        </button>
      </div>
    </div>
  );
};

export default VerifiedCredentialsBlock;
